import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

export const Experience = () => {
  const { c, ui } = useContent();
  return (
    <Section id="experience" num="04" chapter={ui.experience.chapter} className="bg-ivory">
      <Shape3D shape="star" size={50} blue className="absolute left-[3%] top-24 opacity-80 hidden md:block" duration={7} />
      <SectionTitle className="max-w-3xl">
        {ui.experience.titleA} <span className="italic text-cobalt">{ui.experience.titleB}</span>
      </SectionTitle>

      <div className="mt-16 space-y-0">
        {c.experience.map((exp, i) => (
          <Reveal key={exp.role} delay={0.04 * i}>
            <article
              className="group relative grid lg:grid-cols-12 gap-8 py-12 border-t border-line last:border-b"
              data-testid={`experience-item-${i}`}
            >
              <div className="lg:col-span-1 font-serif italic text-3xl text-cobalt/70">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-cobalt transition-colors duration-400">
                  {exp.role}
                </h3>
                <p className="mt-3 text-sm font-bold text-choco/80">{exp.org}</p>
                <p className="mt-1 text-xs tracking-[0.2em] uppercase text-cocoa">{exp.period}</p>
                <p className="mt-5 text-sm leading-relaxed text-cocoa">{exp.summary}</p>
              </div>
              <div className="lg:col-span-4">
                <p className="text-xs tracking-[0.25em] uppercase font-bold text-cobalt">{ui.experience.learned}</p>
                <p className="mt-3 text-base leading-relaxed text-cocoa">{exp.learned}</p>
              </div>
              <div className="lg:col-span-3">
                <p className="text-xs tracking-[0.25em] uppercase font-bold text-cobalt">{ui.experience.impact}</p>
                <p className="mt-3 text-sm leading-relaxed text-cocoa">{exp.impact}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {exp.skills.map((s) => (
                    <span key={s} className="rounded-full bg-beige/70 px-2.5 py-0.5 text-[11px] text-choco">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};
